import { Component, OnInit } from '@angular/core';
import { BaseIcon } from '../base-icon';

@Component({
	selector: 'app-icon-master-ingredient',
	templateUrl: './icon-master-ingredient.component.html',
	styleUrls: ['./icon-master-ingredient.component.scss'],
})
export class IconMasterIngredientComponent extends BaseIcon implements OnInit {
	constructor() {
		super();
	}

	ngOnInit() {}
}
